// extracted by mini-css-extract-plugin
export default {"portal":"sFHX5"};